// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import React from 'react';

import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';


const VoucherAmount = (props) => {
  const {
    classes,
    redeemValue,
  } = props;

  return (
    <div className={classes.container}>
      <p className={classes.descText}>Gift voucher amount:</p>
      <div className={classes.circle}>
        <p className={classes.priceText}>{`£${parseFloat(redeemValue).toFixed(2)}`}</p>
      </div>
    </div>
  );

};

VoucherAmount.propTypes = {
  classes: PropTypes.object,
  redeemValue: PropTypes.number,

};
VoucherAmount.defaultProps = {
  classes: {},
  redeemValue: 0,
};

export default withStyles(styles)(VoucherAmount);
